import React from 'react';

const PaymentLogos: React.FC = () => {
  return (
    <div className="payment-logos-grid">
      <div className="payment-logos-row">
        <img src="/images/payments/Visa.png" alt="Visa" className="payment-logo" />
        <img src="/images/payments/Amex.png" alt="American Express" className="payment-logo" />
        <img src="/images/payments/Discover.png" alt="Discover" className="payment-logo" />
        <img src="/images/payments/Mastercard.png" alt="Mastercard" className="payment-logo" />
      </div>
      <div className="payment-logos-row payment-logos-row-imgonly">
        <img src="/images/payments/PayPal.png" alt="PayPal" className="payment-logo-imgonly" />
        <img src="/images/payments/GooglePay.png" alt="GPay" className="payment-logo-imgonly" />
        <img src="/images/payments/ApplePay.png" alt="Apple Pay" className="payment-logo-imgonly" />
      </div>
    </div>
  );
};

export default PaymentLogos;
